<template>
    <div class="modal fade" id="modalOrderPart" tabindex="-1" role="dialog" aria-labelledby="modalOrderPart" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">{{$t('string.msg.modal.orders.label.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <div class="card" v-if="order && order.systemUser">
                                    <div class="card-header">
                                        <div class="form-row">
                                            <div class="col-md-6">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.parts.label.truckdriver')}}:
                                                </label>
                                                <p>{{` ${camelize(order.systemUser.firstName)} ${camelize(order.systemUser.lastName)}`}}</p>
                                            </div>
                                            <div class="col-md-6">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.distance.title')}}:
                                                </label>
                                                <p> {{(parseInt(order.distance/1000))}} KM</p>
                                            </div>
                                        </div>

                                         <div class="form-row" v-if="order.statusOrder.toUpperCase() == 'PAID'"> 
                                            <div class="col-md-6"> 
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.parts.label.truckdriver.phone')}}:
                                                </label>
                                                <p>{{`${camelize(order.systemUser.primaryPhone)}`}}</p>
                                            </div>
                                        </div>        

                                        <div class="form-row">
                                            <div class="col-md-6" v-if="order.manufacturer">
                                                <label  class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.manucfacturer.title')}}:
                                                </label>
                                                <p>{{` ${camelize(order.manufacturer.name)}`}}</p>
                                            </div>
                                            <div class="col-md-6" v-if="order.family">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.family.title')}}:
                                                </label>
                                                <p>{{` ${camelize(order.family.name)}`}}</p>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="col-md-6" v-if="order.truckModel">
                                                <label  class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.model.title')}}:
                                                </label>
                                                <p>{{` ${camelize(order.truckModel.name)}`}}</p>
                                            </div>
                                            <div class="col-md-6" v-if="order.truckYear">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.year.title')}}:
                                                </label>
                                                <p>{{ order.truckYear}}</p>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <label  class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.description.title')}}:
                                                </label>
                                                <span>{{` ${camelize(order.description)}`}}</span>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <label  class="col-form-label">
                                                    {{$t('string.msg.order.payment.method.label')}}:
                                                </label> 
                                                    <span v-if="order.paymentMethod">{{` ${camelize(order.paymentMethod)}`}}</span>
                                                    <span v-if="order.paymentType">{{` ${camelize(order.paymentType)}`}}</span>
                                            </div>    
                                        </div>
                                         <div class="form-row">
                                            <div class="col-md-7">
                                                <label class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    {{$t('string.msg.order.have.parts.label')}}
                                                </label>
                                            </div>
                                            <div class="col-md-5">
                                                <input size="25" type="radio" id="yesStock" :value="true" v-model="data.companyIsPartAvailable"> 
                                                <label class="col-form-label" for="yesStock"><strong >{{$t('string.msg.order.in.stock.label.yes')}}</strong></label> &nbsp; &nbsp;
                                                  <input type="radio" id="noStock" :value="false" v-model="data.companyIsPartAvailable"> 
                                                <label class="col-form-label" for="noStock"><strong style="color:red">{{$t('string.msg.order.in.stock.label.no')}}</strong></label>
                                            </div>
                                        </div><br/>
                                        <div class="form-row">
                                            <div class="col-md-7">
                                                <label class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    {{$t('string.msg.order.delivery.label')}}
                                                </label>
                                            </div>
                                            <div class="col-md-5">
                                                <input type="radio" id="yesDelivery" :value="true" v-model="data.companyIsDelivery"> 
                                                <label class="col-form-label" for="yesDelivery"><strong >{{$t('string.order.parts.company.label.yes')}}</strong></label> &nbsp; &nbsp;
                                                  <input type="radio" id="noDelivery" :value="false" v-model="data.companyIsDelivery"> 
                                                <label class="col-form-label" for="noDelivery"><strong style="color:red">{{$t('string.order.parts.company.label.no')}}</strong></label>
                                            </div>
                                        </div><br/>
                                        <div class="form-row">
                                            <div class="col-md-7">
                                                <label class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    {{$t('string.msg.order.original.label')}}
                                                </label>
                                            </div>
                                            <div class="col-md-5" >
                                                <input type="radio" id="yesOriginal" :value="true" v-model="data.companyIsPartOriginal"> 
                                                <label class="col-form-label" for="yesOriginal"><strong >{{$t('string.msg.order.in.stock.label.yes')}}</strong></label> &nbsp; &nbsp;
                                                <input type="radio" id="noOriginal" :value="false" v-model="data.companyIsPartOriginal"> 
                                                <label class="col-form-label" for="noOriginal"><strong style="color:red">{{$t('string.msg.order.in.stock.label.no')}}</strong></label>
                                            </div>
                                        </div>
                                        <div class="form-row" >
                                             <div class="col-md-4">
                                                 <label class="col-form-label">
                                                    {{$t('string.msg.order.manufacturer.msg.label')+':'}} &nbsp;
                                                </label>
                                            </div>
                                            <div class="col-md-8">
                                                <input type="text" id="descriptionPart" v-model="data.companyPartBrand" maxlength="100" size="54"/>
                                            </div>
                                        </div><br/>
                                        <!-- <div class="form-row" >
                                            <div class="col-md-5">
                                                 <label class="col-form-label">
                                                    {{$t('string.msg.order.description.part.label')+':'}} &nbsp;
                                                </label>
                                            </div>
                                            <div class="col-md-7">
                                                <input type="text" id="descriptionPart" v-model="descriptionPart" maxlength="100" size="32"/>
                                            </div>
                                        </div><br/> -->
                                        <div class="form-row">
                                            <div class="col-md-7">
                                                <label class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    {{$t('string.msg.order.information.ok.label')}}
                                                </label>
                                            </div>
                                           <div class="col-md-5" >
                                                <input type="radio" id="yesInformation" :value="true" v-model="data.companyIsInfosSufficient"> 
                                                <label class="col-form-label" for="yesInformation"><strong >{{$t('string.msg.order.in.stock.label.yes')}}</strong></label> &nbsp; &nbsp;
                                                <input type="radio" id="noInformation" :value="false" v-model="data.companyIsInfosSufficient"> 
                                                <label class="col-form-label" for="noInformation"><strong style="color:red">{{$t('string.msg.order.in.stock.label.no')}}</strong></label>
                                            </div>
                                        </div>
                                        <div class="form-row" v-show="data.companyIsInfosSufficient == false">
                                            <div class="col-md-12">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.order.company.msg.label')+':'}} &nbsp;
                                                </label>
                                                <input type="text" id="information" v-model="data.companyAddionalInformations" maxlength="100" size="42" />
                                            </div>
                                        </div><br/>
                                        <div class="form-row">
                                            <div class="form-group col-md-6">
                                                <label  class="col-form-label">
                                                    <code class="highlighter-rouge">*</code>
                                                    {{$t('string.msg.modal.orders.price')}}:
                                                </label>
                                                <input  v-money="money" id="salary" v-model="data.total" type="text" class="form-control" :placeholder="$t('string.msg.product.parts.placeholder.price')" />
                                            </div>    
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-md-6">
                                <div class="card">
                                    <div class="card-header" v-if="trucks && trucks.length > 0">
                                        <div class="col-md-12" v-bind:key="truck._id" v-for="(truck, index) in trucks">
                                            <label class="col-form-label">
                                                <strong>{{(index + 1) + 'º - '}}</strong>
                                                <strong>{{$t('string.msg.modal.orders.truck.manufacturer')+ ':'}}</strong>&nbsp;<span v-if="truck.manufacturer && truck.manufacturer.name">{{truck.manufacturer.name}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.infos')+ ':'}}</strong>&nbsp;{{ truck.vehicleType ?  $t(truck.vehicleType) : ''}}&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.model')+ ':'}}</strong>&nbsp;<span>{{truck.model && truck.model.name ? truck.model.name : ''}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.year')+ ':'}}</strong>&nbsp;<span v-if="truck.year"></span><span v-else> {{$t('str.msg.uninformed.information')}}</span> {{truck.year}}&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.chassi')+ ':'}}</strong>&nbsp;<span v-if="truck.chassi"> {{truck.chassi}}</span><span v-else> {{$t('str.msg.uninformed.information')}}</span>
                                            </label>
                                        </div>
                                    </div>
                                        
                                    <div v-else class="card-header" >
                                        <div class="form-row">
                                            <div class="col-md-12">
                                                <p>
                                                    {{ $t('string.msg.nothing.found.truck') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>    
                                </div>     
                            </div>
                        </div>    
                         
                    </form>
                    <div v-if="errors.length" class="alert alert-danger">
                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                        <ul>
                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                        </ul>
                    </div>
                    
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{$t('string.msg.term.btn.cancel')}}</button>
                    <button type="button" class="btn btn-primary"  v-on:click="checkForm()">{{$t('string.msg.modal.orders.btn.send')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Controller from './CrtModalOrderPart';

  export default {
        props: ["order"],
        watch:{
            'order'(){
                this.order = this.order;
                this.data.companyAddionalInformations = this.order.companyAddionalInformations;
                this.data.companyIsDelivery = this.order.companyIsDelivery;
                this.data.companyIsInfosSufficient = this.order.companyIsInfosSufficient;
                this.data.companyIsPartAvailable = this.order.companyIsPartAvailable;
                this.data.companyIsPartOriginal = this.order.companyIsPartOriginal;
                this.data.companyPartBrand = this.order.companyPartBrand;
                if(this.order.total)
                {
                    this.data.total = this.order.total.toFixed(2);
                }

                if(this.order.systemUser && this.order.systemUser._id){
                    this.systemUser = this.order.systemUser._id;
                    this.getTrucksByUser();
                }
            }
        },
        data() {
            return {
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
                items: [],
                trucks: [],
                systemUser: null,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                data: {
                    total: 0.0,
                    companyIsInfosSufficient: null,
                    companyPartBrand: null,
                    companyAddionalInformations: null,
                    companyIsPartAvailable: null,
                    companyIsPartOriginal: null,
                    companyIsDelivery: null    
                }
            }
        },
        methods: Controller.methods,
        created() {
        },
        mounted(){
            Controller.init(this);
        }
    }
</script>

